module.exports = __webpack_public_path__ + "img/back neck drop.ad4b98cf.png";